(function() {

    'use strict';



    SAPO.namespace('Utility');



    /**
     * @class Mediator
     * @param  {Object} o
     * @... {Boolean} debug
     * @... {Boolean} catchExceptions
     * @... {Boolean} debug
     * @return {Object} returns API
     */
    var Mediator = function(o) {

        var subscribers = {}; // array of subscribers with msgType/topic as key



        var publish = function(msgType/*, remaining args*/) {
            /*global console:false */

            var args = Array.prototype.slice.call(arguments);

            if (o.debug) {
                try {
                    console.log('>> ' + JSON.stringify(args));
                } catch (ex) {
                    console.log('>> ' + args.join(' '));
                }
            }

            var msgTypeSubscribers = subscribers[msgType];
            if (!msgTypeSubscribers) { return; }

            var fn =
                o.catchExceptions ?
                function(l) {
                    if (!l || l.length < 2) { return; } // TODO WEIRD!

                    try {
                        l[1].apply(l[0], args);
                    } catch (ex) {
                        /*if (window.console && window.console.log) {
                            console.log(ex.stack || ex.message || ex);
                        }*/
                    }
                } :
                function(l) {
                    if (!l || l.length < 2) { return; } // TODO WEIRD!

                    l[1].apply(l[0], args);
                };

            for (var i = 0, f = msgTypeSubscribers.length; i < f; ++i) {
                fn( msgTypeSubscribers[i] );
            }
        };



        var publishDelayed = function() {
            var args = Array.prototype.slice.call(arguments);
            var ms = 0;
            if (typeof args[0] === 'number') {
                ms = args.shift();
            }
            setTimeout(
                function() {
                    var ctx = this.ctx;
                    publish.apply(ctx, this.args);
                }.bindObj({ctx:this, args:args}),
                ms
            );
        };



        var subscribe = function(msgType, cbFn, subscriberOverride) {
            /*jshint maxcomplexity: 20 */
            var subscriber = subscriberOverride || this;
            var that = this;


            // divide list of msgTypes into their own calls

            if (msgType.indexOf(' ') !== -1) {
                msgType = msgType.split(' ');
            }

            if (msgType instanceof Array) {
                for (var i = 0, f = msgType.length; i < f; ++i) {
                    that.subscribe(msgType[i], cbFn, subscriber);
                }
                return;
            }


            // determines callback function

            if (!cbFn && subscriber === SAPO.Utility.Mediator) {
                throw new Error('Either call without cb after having it installed in your instance or call with a cb!');
            }

            if (!cbFn) { cbFn = subscriber['on_' + msgType]; }
            if (!cbFn) { cbFn = subscriber.on; }
            if (!cbFn) {
                console.error('No suitable callback function found for msgType: ' + msgType);
                console.error('and context:');
                console.error(subscriber);
                throw new Error();
            }


            // check types

            if (typeof msgType !== 'string') {   throw new TypeError('msgType must be a string!');    }
            if (typeof cbFn    !== 'function') { throw new TypeError('callback must be a function!'); }


            // do the actual subscription

            var msgTypeSubscribers = subscribers[msgType];
            var existed = !!msgTypeSubscribers;

            if (!existed) {
                msgTypeSubscribers = [];
            }

            msgTypeSubscribers.push([subscriber, cbFn]);

            if (!existed) {
                subscribers[msgType] = msgTypeSubscribers;
            }
        };



        var once = function(msgType, cbFn) {
            var cbFn2 = function() {
                cbFn.apply(null, arguments);
                unsubscribe(msgType, cbFn);
            };
            subscribe(msgType, cbFn2);
        };



        var unsubscribe = function(msgType, cbFn, subscriberOverride) {
            var subscriber = subscriberOverride || this;
            var i, f, that = this;


            // handle array form

            if (msgType.indexOf(' ') !== -1) {
                msgType = msgType.split(' ');
            }

            if (msgType instanceof Array) {
                for (i = 0, f = msgType.length; i < f; ++i) {
                    that.unsubscribe(msgType[i], subscriber);
                }
                return;
            }


            // do the actual unsubscription

            var msgTypeSubscribers = subscribers[msgType];

            if (!msgTypeSubscribers) { return; }

            for (i = 0, f = msgTypeSubscribers.length; i < f; ++i) {
                if (msgTypeSubscribers[i][1] === cbFn ||
                    msgTypeSubscribers[i][0] === subscriber) {
                    return msgTypeSubscribers.splice(i, 1);
                }
            }

            throw new Error('Couldn not find the subscriber assigned to the given msgType!');
        };



        var installTo = function(ctx) {
            ctx.publish        = publish;
            ctx.publishDelayed = publishDelayed;
            ctx.subscribe      = subscribe;
            ctx.unsubscribe    = unsubscribe;
        };



        return {
            publish:        publish,
            publishDelayed: publishDelayed,
            subscribe:      subscribe,
            unsubscribe:    unsubscribe,
            once:           once,
            installTo:      installTo
        };
    };



    SAPO.Utility.Mediator = Mediator;

})();
